// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"c0a328eb","633":"0c8bf0ec","816":"fd8c26c2"}[chunkId] + ".chunk.js";
};